import { Spinner, SpinnerSize } from "@blueprintjs/core";
import { MouseEvent } from "react";
import { styles } from "../styles";
import Icon from "../../Icon";
import Button from "../../Button";
import { UploaderProps } from "../types";
import FileCard from "../../FileCard";
import Clickable from "../../Clickable";

type UploaderFileListItemProps = {
  file: File;
  onDelete: () => void;
  error?: string;
  onReselect?: () => void;
  processing?: boolean;
  variant?: UploaderProps["listVariant"];
};

const UploaderFileListItem = ({
  file,
  onDelete,
  error,
  processing,
  onReselect,
  variant = "default"
}: UploaderFileListItemProps) => {
  const reselect = (event: MouseEvent) => {
    event.stopPropagation();
    onReselect && onReselect();
  };

  if (variant === "cards") {
    return (
      <FileCard
        file={file}
        error={error}
        loading={processing}
        actions={
          <Clickable aria-label="Remove file" onClick={onDelete}>
            <Icon name="Circled.X" fill="var(--color-secondary)" />
          </Clickable>
        }
      />
    );
  }

  return (
    <div
      className="subKit-UploaderFileListItem"
      css={styles.fileRow}
      key={`${file.name}-${file.lastModified}`}
    >
      <div css={[styles.leftContent]}>
        {!!processing && <Spinner size={SpinnerSize.SMALL} />}
        {!processing && !!error && (
          <Icon
            name="Circled.Exclamation"
            size="small"
            fill="var(--color-danger)"
          />
        )}
        {!processing && !error && (
          <Icon name="Circled.Check" fill="var(--color-success)" />
        )}
        <div>
          <span css={styles.fileName}>{file.name}</span>
          {!!error && <span css={styles.fileError}>{error}</span>}
        </div>
      </div>
      <div css={styles.rightContent}>
        {!!onReselect && (
          <Button variant="ghost" onClick={reselect}>
            Reselect
          </Button>
        )}
        <Button
          variant="ghost"
          prefix={
            <Icon
              name={error || processing ? "X" : "Trash"}
              fill="var(--color-secondary, var(--color-primary))"
            />
          }
          onClick={e => {
            e.stopPropagation();
            onDelete();
          }}
        />
      </div>
    </div>
  );
};

export default UploaderFileListItem;
